import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export const YesNoModal: React.FC = () => {
  const [show, setShow] = useState(true);

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header>
        <Modal.Title>Hinweis</Modal.Title>
      </Modal.Header>
      <Modal.Body>Warning: the uploaded report is not financial report!</Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setShow(false);
          }}
        >
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
